
import { defineComponent, onMounted, ref, getCurrentInstance, computed, watch, SetupContext } from 'vue';
import Skeleton from 'vant/lib/skeleton';
import UserItemFollow from '../user-item-follow/index.vue';
import MutedIcon from '../muted/index.vue';
import Loading from '@/components/loading/index.vue';
// import { timeStampToDisplayString } from '@/common/utils';
import { sendLog } from '~/common/radar';
import { MobilePageSource } from '@/constants/base';
import { getLlsidFromExptag } from '@/common/common-params';
// TODO: 每播放一个视频就自动滑动到下一个

export default defineComponent({
    components: {
        UserItemFollow,
        MutedIcon,
        Loading,
        Skeleton,
    },
    // filters: {
    //   timeFormate(val: number) {
    //     if (!val) return;
    //     return timeStampToDisplayString(val);
    //   },
    // },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
        muted: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: () => '',
        },
        index: {
            type: Number,
            default: 0,
        },
        firstCardFinishLoad: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, ctx: SetupContext<Array<'onFirstFinishRender'>>) {
        const { proxy } = getCurrentInstance() as { proxy: any };
        const photoList = ref([] as any);
        const videoListEle = ref(null);
        const videoWrap = ref(null);
        const videoWrapWidth = ref(0);
        // 当前正在播放的视频
        const playingIndex = ref(0);
        const startPlayTime = ref(0);
        const userVideoComps = ref([] as any);
        const cardType = ref('user-video-card');

        const authorInfo = computed(() => props.data.authorInfo ?? {});

        watch(
            () => props.data,
            val => {
                if (val) {
                    photoList.value = [...props.data.feeds]?.map((item: any) => ({
                        ...item,
                        isPlaying: false,
                        loading: false,
                        timestamp: timeStampToDisplayString(item.timestamp, proxy),
                    }));
                }
            },
            {
                immediate: true,
            }
        );

        // 视频播放相关方法
        let videoElement: any;

        const getVideoEle = () => {
            console.log('uservideocard getVideoEle-->', playingIndex.value, userVideoComps.value[playingIndex.value]);
            return userVideoComps.value[playingIndex.value];
        };

        function timeStampToDisplayString(timestamp: number, proxy: any) {
            // 获取当前时间戳以及一天的时间戳
            const now = Date.now();
            const oneDay = 24 * 60 * 60 * 1000;

            // 计算时间戳和当前时间之间的差距
            const timeDiff = now - timestamp;

            // 判断是否在24小时内 k_430982
            if (timeDiff < oneDay) {
                return proxy.$root.$t('k_430982');
            }

            // 判断是否在七天内
            if (timeDiff < 7 * oneDay) {
                // 计算相差的天数
                const diffDays = Math.floor(timeDiff / oneDay);
                return proxy.$root.$t('k_430983').replace('${0}', diffDays);
            }
            // 7天外
            return proxy.$root.$t('k_430983').replace('${0}', 7);
        }

        // 更新视频播放状态的icon
        const handleIconChange = (index: number) => {
            photoList.value?.forEach((item: any, idx: number) => {
                photoList.value[idx].isPlaying = idx === index;
            });
        };

        const handleOnPause = (index: number) => {
            photoList.value[index].isPlaying = false;
            photoList.value[index].loading = false;
            const videoComp = getVideoEle();
            const playTime = videoComp?.getCurrentTime() || 0;
            const duration = videoComp?.getDuration() || 0;
            console.log('handlePause-->', props.index, playTime, duration);
            if (playTime > 0 && photoList.value[index].photo_id_str && duration > 0) {
                sendLog({
                    type: 'click',
                    name: 'PLAY_TIME_MOBILE',
                    value: {
                        photo_id: photoList.value[index].photo_id_str,
                        author_id: photoList.value[index].user_id,
                        play_time: playTime,
                        photo_time: duration,
                        if_error: 0,
                        exp_tag: photoList?.value[index]?.exp_tag,
                        llsid: getLlsidFromExptag(photoList?.value[index]?.exp_tag),
                    },
                });
            }
            startPlayTime.value = new Date().getTime();
        };

        const handlePhotoClick = (index: number) => {
            const photo = photoList.value[index];
            sendLog({
                type: 'click',
                name: 'PHOTO_COVER',
                value: {
                    author_id: photo.user_id,
                    photo_id: photo.photo_id_str,
                    like: photo.like_count,
                    play: photo.view_count,
                    comment: photo.comment_count,
                    card_type: 'user_photo',
                },
            });
            proxy.$router.push({ path: `/@${props.data?.authorInfo?.kwaiId}/video/${photo.photo_id_str}`, query: { page_source: 'new_discover' } });
        };

        const clickPlayOrPause = (index: number) => {
            // 若当前正在播放的视频非点击的视频，则先暂停；
            if (index !== playingIndex.value) {
                // setVideoPause();
                setAllVideoPause();
                handleIconChange(-1);
                // 并更新当前选择的视频元素
                playingIndex.value = index;
                videoElement = getVideoEle();
                setVideoPlay();
                handleIconChange(index);
                return;
            }

            // 若当前正在播放视频是点击的视频，则直接暂停
            if (photoList.value[index].isPlaying) {
                setVideoPause();
                photoList.value[index].isPlaying = false;
                photoList.value[index].loading = false;
                handleIconChange(-1);
            } else {
                photoList.value[index].isPlaying = true;
                photoList.value[index].loading = false;
                setVideoPlay();
            }
        };

        const setVideoPlay = () => {
            if (!videoElement) {
                videoElement = getVideoEle();
            }
            sendLog({
                type: 'click',
                name: 'PHOTO_CARD_SPECIAL',
                value: {
                    button_type: 'play',
                    card_type: 'photo_card',
                },
            });
            videoElement?.play();
        };

        const setVideoPause = () => {
            if (!videoElement) {
                videoElement = getVideoEle();
            }
            sendLog({
                type: 'click',
                name: 'PHOTO_CARD_SPECIAL',
                value: {
                    button_type: 'pause',
                    card_type: 'photo_card',
                },
            });
            videoElement?.pause();
        };

        const setAllVideoPause = () => {
            userVideoComps.value.forEach((item: any) => {
                item?.pause();
            });
        };

        const onEnded = () => {};

        // 跳转用户p页
        const handleProfile = () => {
            if (props.data?.authorInfo?.kwaiId) {
                proxy.$bus.emit('jumpProfile', props.data.authorInfo?.kwaiId);
            }
        };

        const handleOnplaying = (index: number) => {
            // 播放哪个
            playingIndex.value = index;
            photoList.value[index].isPlaying = true;
            photoList.value[index].loading = false;
            videoElement = getVideoEle();
        };

        const handleCanPlay = (index: number) => {
            // eslint-disable-next-line vue/require-explicit-emits
            ctx.emit('onFirstFinishRender', index);
        };

        const handleOnPlay = (index: number) => {
            photoList.value[index].loading = true;
            startPlayTime.value = new Date().getTime();
        };

        onMounted(() => {
            videoElement = getVideoEle();
            // setVideoPlay();
            handleIconChange(playingIndex.value);
            videoWrapWidth.value = (videoWrap.value as any as HTMLElement[])?.[0]?.clientWidth;

            // const box = (videoListEle.value as any) as HTMLDivElement;
            // box.addEventListener('scroll', (e) => {
            //   if (box.scrollLeft + 5 >= box.scrollWidth - box.clientWidth) {
            //     handleProfile();
            //   }
            // });
        });

        return {
            photoList,
            playingIndex,
            handleOnPause,
            clickPlayOrPause,
            handleOnplaying,
            handlePhotoClick,
            onEnded,
            handleProfile,
            handleOnPlay,
            handleCanPlay,
            authorInfo,
            videoListEle,
            videoWrap,
            cardType,
            userVideoComps,
            bizData: { pageSource: MobilePageSource.PwaDiscoverUserVideo },
        };
    },
});
